import styled from "styled-components";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

export const AccortdianD = styled(AccordionDetails)`
     .MuiAccordionDetails-root {
      display: unset !important; 
      padding: 0px !important; 
 }
`
export const CAccordionSummary = styled(AccordionSummary)`
    .MuiAccordionSummary-content{
      display: inline !important;  
 }
`

